import React, { forwardRef, KeyboardEvent } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import clsx from 'clsx';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  variant?: 'text' | 'contained' | 'outlined';
  color?: 'inherit' | 'primary' | 'secondary';
  href?: string;
  classWrap?: string;
  onKeyDown?: (e: KeyboardEvent<HTMLButtonElement>) => void;
  startIcon?: ButtonProps['startIcon'];
  endIcon?: ButtonProps['endIcon'];
  sx?: ButtonProps['sx'];
};

const CustomButton = forwardRef<HTMLButtonElement, Props>(({
  onClick,
  children,
  className = '',
  disabled = false,
  type = 'button',
  variant = 'contained',
  color = 'inherit',
  href,
  classWrap,
  onKeyDown,
  startIcon,
  endIcon,
  sx,
}: Props, ref) => {
  const containedVariant = variant === 'contained';
  const clsxClass = clsx(
    className,
    {
      '!bg-populate-green hover:!bg-populate-deep-green !text-white': containedVariant,
    },
  );
  const btnColors: Record<string, 'primary' | 'secondary'> = {
    primary: 'secondary',
    secondary: 'primary',
  };
  const btnWrapClass = clsx('custom-button my-1', classWrap);
  return (
    <div
      className={btnWrapClass}
    >
      <Button
        ref={ref}
        variant={variant}
        disabled={disabled}
        type={type}
        onClick={onClick}
        className={clsxClass}
        color={btnColors[color] || 'inherit'}
        href={href}
        onKeyDown={onKeyDown}
        startIcon={startIcon}
        endIcon={endIcon}
        sx={sx}
      >
        {children}
      </Button>
    </div>
  );
});

export default CustomButton;
